module.exports = __webpack_public_path__ + "img/title-2.a11117c4.png";